import { Team } from "./Team";
import { z } from "zod";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const Teams = z.object({
    teams: Team.array(),
});

export type Teams = z.infer<typeof Teams>;
